import { useMemo } from "react";
import { bindActionCreators } from "redux";
import "../../../../entities/banks/model/index.js";
import { slice, actions } from "../../../../features/choice/model/slice.js";
import "../../../store/config/middleware/index.js";
import { slice as slice$2, actions as actions$2 } from "../../../store/config/model/slice.js";
import { useAppDispatch } from "./useAppDispatch.js";
import { slice as slice$1, actions as actions$1 } from "../../../../entities/banks/model/slice.js";
const useAppActions = () => {
  const dispatch = useAppDispatch();
  const createAction = (actions2) => bindActionCreators(actions2, dispatch);
  return useMemo(
    () => ({
      [slice$2.reducerPath]: createAction(actions$2),
      [slice$1.reducerPath]: createAction(actions$1),
      [slice.reducerPath]: createAction(actions)
    }),
    []
  );
};
export {
  useAppActions
};
